<template>
  <div class="our-story white">
    <v-container grid-list-lg>
      <v-layout column>
        <v-flex
          class="display-2 font-weight-black orange--text darken-4 text-center my-5"
          >Our Story</v-flex
        >
        <v-flex class="subheading text-black">
          <p>
            Back in 2010, a small group of high-performing sales consultants
            became good friends at a well-known company, Carphone Warehouse.
            Their friendship blossomed over a few years until one turning point;
            Upload 2013.
          </p>
          <p>
            Naturally, our banter led to creating a mock festival; the opposite
            to Download. Ideas were …
          </p>
          <ul>
            <li>Instead of rock music, we would have classical music</li>
            <li>Instead of a dog mascot, a cat mascot</li>
            <li>Instead of a weekend, one night only</li>
          </ul>
          <br />
          <p>
            Although James likes to believe that he was the original organiser
            of the very first Upload 2013, it was in actual fact, Tammy. As you
            can see below, we have a screenshot of the email circulated around
            the original Uploaders.
          </p>

          <v-carousel height="auto">
            <v-carousel-item
              eager
              v-for="(item, i) in items"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>

          <br />
          <p><b>Sorry, not sorry.</b></p>
        </v-flex>
      </v-layout>
    </v-container>
    <v-flex
      class="display-2 font-weight-black orange--text darken-4 text-center my-5"
      >Timeline</v-flex
    >
    <Timeline></Timeline>
  </div>
</template>

<script>
// @ is an alias to /src
import Timeline from '@/components/Timeline';

export default {
  name: 'Home',
  data: () => {
    return {
      items: [
        {
          src: 'https://i.ibb.co/SrRxqCP/1.jpg'
        },
        {
          src: 'https://i.ibb.co/z4WdKHg/2.jpg'
        },
        {
          src: 'https://i.ibb.co/kycDQKz/3.jpg'
        }
      ]
    };
  },
  components: {
    Timeline
  }
};
</script>
<style>
.v-carousel {
  height: 800px;
  width: 500px;
  margin: 0 auto;
}
</style>
